import React from 'react';
import { styled } from '@mui/material/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';

import { Card, CardContent, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';

import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/DeleteOutline';
import Fab from '@mui/material/Fab';
import ListItemText from '@mui/material/ListItemText';
import { Link as RouterLink } from 'react-router-dom';

const PREFIX = 'UsersTable';

const classes = {
  root: `${PREFIX}-root`,
  content: `${PREFIX}-content`,
  inner: `${PREFIX}-inner`,
  nameContainer: `${PREFIX}-nameContainer`,
  avatar: `${PREFIX}-avatar`,
  actions: `${PREFIX}-actions`,
  fab: `${PREFIX}-fab`,
};

const StyledCard = styled(Card)(({ theme }) => ({
  [`&.${classes.root}`]: {},

  [`& .${classes.content}`]: {
    padding: 0,
  },

  [`& .${classes.inner}`]: {
    minWidth: 600,
  },

  [`& .${classes.nameContainer}`]: {
    display: 'flex',
    alignItems: 'center',
  },

  [`& .${classes.avatar}`]: {
    marginRight: theme.spacing(2),
  },

  [`& .${classes.actions}`]: {
    justifyContent: 'flex-end',
  },

  [`& .${classes.fab}`]: {
    margin: theme.spacing(1),
  },
}));

const UsersTable = props => {
  const { className, users, handleDelete, ...rest } = props;

  return (
    <StyledCard {...rest} className={clsx(classes.root, className)}>
      <CardContent className={classes.content}>
        <div className={classes.inner}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Пользователь</TableCell>
                <TableCell>Последняя активность</TableCell>
                <TableCell></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {users.map(user => (
                <TableRow className={classes.tableRow} hover key={user.userId}>
                  <TableCell>
                    <ListItemText primary={user.displayName} secondary={user.email} />
                  </TableCell>
                  <TableCell>
                    {user.active ? (user.lastActivity ? user.lastActivity.substr(0, 10) : 'Never seen') : 'Inactive'}
                  </TableCell>
                  <TableCell>
                    <RouterLink to={'/user/id/' + user.userId}>
                      <Fab size='small' color='secondary' aria-label='edit' className={classes.fab}>
                        <EditIcon />
                      </Fab>
                    </RouterLink>
                    <Fab
                      size='small'
                      color='secondary'
                      aria-label='delete'
                      className={classes.fab}
                      onClick={() => handleDelete(user.userId)}
                    >
                      <DeleteIcon />
                    </Fab>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      </CardContent>
    </StyledCard>
  );
};

UsersTable.propTypes = {
  className: PropTypes.string,
  users: PropTypes.array.isRequired,
  handleDelete: PropTypes.func,
};

export default UsersTable;
